import {useDomainStore} from '@/stores/domain';

const pathsWithHostReplasement = [
    '/files', '/media', '/images', '/pdf', '/img',
];
const BASE_DOMAIN = 'centrinvest.ru';

export default function({route: {fullPath}, redirect}) {
    const domainStore = useDomainStore();

    try {
        if (domainStore.domain.includes(BASE_DOMAIN)) {
            return;
        }

        const isAllowReplacement = pathsWithHostReplasement.some((path) => fullPath.startsWith(path));
        if (isAllowReplacement) {
            redirect(`https://www.${BASE_DOMAIN}${fullPath}`);
        }
    } catch (error) {
        console.error(error);
    }
};
